import PropTypes from 'prop-types';
import React from 'react';
import ClassicLayout from '../../common/components/ClassicLayout';
import BaseContainer from '../../common/components/BaseContainer';

const ProductGroupContainer = props => {
  return <BaseContainer { ...props } Component={ ClassicLayout } />;
};

ProductGroupContainer.propTypes = {
  sectionTitle: PropTypes.string,
  imageCropMethod: PropTypes.string,
  renderMode: PropTypes.string,
  category: PropTypes.string,
  section: PropTypes.string,
  isReseller: PropTypes.bool,
  order: PropTypes.any,
  sampleProductsData: PropTypes.object,
  isInternalPage: PropTypes.bool,
  staticContent: PropTypes.object,
  shopRoute: PropTypes.string,
  domainName: PropTypes.string,
  useStaticData: PropTypes.bool,
  smartRibbonsSale: PropTypes.bool,
  smartRibbonsBestseller: PropTypes.bool,
  smartRibbonsNewProduct: PropTypes.bool,
  smartRibbonsSaleOption: PropTypes.string,
  smartRibbonsBestsellerOption: PropTypes.string,
  smartRibbonsNewProductOption: PropTypes.string,
  smartRibbonStyle: PropTypes.string
};

export default ProductGroupContainer;
